/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * Browser entry: wrap the app in Auth0, catch Auth0 errors, and load global CSS.
 */

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { Auth0ProviderWithNavigate } from "./Auth0ProviderWithNavigate";
import { Auth0ErrorBoundary } from "./components/Auth0ErrorBoundary";
import "./styles/styles.css";
import "./styles/lexend-fonts.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <React.StrictMode>
      <BrowserRouter>
        <Auth0ErrorBoundary>
          <Auth0ProviderWithNavigate>
            <App />
          </Auth0ProviderWithNavigate>
        </Auth0ErrorBoundary>
      </BrowserRouter>
    </React.StrictMode>
);
